<div class="card">
  <app-grid-client-side
    storageKey="companies"
    [loading]="isLoading()"
    [defaultExcelExportParams]="excelExportParams"
    [defaultCsvExportParams]="csvExportParams"
    [pinFirstColumnName]="pinFirstColumnName"
    [excelStyles]="excelStyles"
    [rowData]="companiesList"
    [colDefs]="$any(colDefs())"
    [pageTitle]="pageTitle"
    (gridReady)="onGridReady($event)"
    (select)="selectCompanies($event)"
  >
    <div
      class="grid-controls-middle d-flex justify-content-end gap-12"
      *appHasRole="['Admin', 'Manager', 'Preparer']"
    >
      <div
        *appHideProd
        ngbDropdown
        class="dropdown company-registration-dropdown"
        [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
      >
        <app-button
          ngbDropdownToggle
          text="Register Company"
          iconClass="icon ic-add-20"
          [isDisabled]="modalOpened()"
        />

        <div ngbDropdownMenu aria-labelledby="register-company-actions-dd"
             class="common-dropdown-menu dropdown-menu dropdown-menu-right">
          <button ngbDropdownItem class="dropdown-item" (click)="openCompanyRegistrationForm()">
            <div>
              <div class="action-title">Standard Company</div>
              <div class="action-description">
                This service involves the setup and registration of a Proprietary Limited
                Company with ASIC.
              </div>
            </div>
          </button>

          <button ngbDropdownItem class="dropdown-item" (click)="openCompanyRegistrationForm(true)">
            <div>
              <div class="action-title">Special Purpose Company - SMSF Trustee</div>
              <div class="action-description">
                This service involves setting up and registering a Special Purpose Company
                that will function exclusively as the Trustee of a Self Managed Super Fund.
              </div>
            </div>
          </button>
        </div>
      </div>

      <app-button
        text="Add"
        title="Add Company"
        btnColor="white"
        iconClass="icon ic-add-20"
        [isDisabled]="modalOpened()"
        (clickBtn)="openAppointCompanyForm()"
      />
    </div>

    <div class="grid-controls-refresh">
      <button
        [ngbTooltip]="'Refresh Companies List'"
        tooltipClass="tooltip-info"
        container="body"
        placement="top"
        type="button"
        class="btn btn-secondary btn-icon"
        [disabled]="modalOpened() || isCompanyListRefreshLoading()"
        (click)="onRefreshCompanyList()"
      >
        <i
          class="icon ic-refresh-20"
          [class.rotating]="isCompanyListRefreshLoading()"
        ></i>
      </button>
    </div>

    <div
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      class="grid-controls-end d-flex gap-12"
    >
      @if (checkedCompanies.length) {
        <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown">
          <app-button
            ngbDropdownToggle
            class="hide-button-text-thin-page"
            id="bulk-actions-dd"
            text="Actions"
            iconClass="icon ic-select-20"
            [iconLast]="true"
            [isDisabled]="modalOpened()"
          />
          <div ngbDropdownMenu aria-labelledby="bulk-actions-dd"
               class="common-dropdown-menu dropdown-menu dropdown-menu-right">
            <button class="dropdown-item" (click)="redirectToChangeAddressInBulk()">
              <span>Change of Address</span>
            </button>

            <button class="dropdown-item" (click)="openBulkAppointOfficeholderForm()">
              <span>Appoint an Officeholder</span>
            </button>

            <button class="dropdown-item" (click)="openBulkCeaseOfficeholderForm()">
              <span>Cease an Officeholder</span>
            </button>

            <button class="dropdown-item" (click)="openBulkCeaseRegisteredAgentForm()">
              <span>Cease as a Registered Agent</span>
            </button>

            <button class="dropdown-item" (click)="openEditPartnerAndAccountManagerModal(null)">
              <span>Edit Partner and Account Manager</span>
            </button>

            <button class="dropdown-item" (click)="exportSelectedCompaniesToXls()">
              <span>Export List of Companies to xlsx</span>
            </button>

<!--            <button class="dropdown-item" (click)="exportSelectedCompaniesToCsv()">-->
<!--              <span>Export to csv</span>-->
<!--            </button>-->

            <button class="dropdown-item" (click)="openManageTagsModal()">
              <span>Manage Tags</span>
            </button>
          </div>
        </div>
      } @else {
        <app-button
          id="export-company-list-dd"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!companiesList.length || modalOpened()"
          (clickBtn)="exportCompanyList(false)"
        />
      }
    </div>
  </app-grid-client-side>
</div>

<app-notes
  [entityType]="EntityType.Company"
  [entity]="entityForNotes"
  [opened]="notesVisible"
  (close)="notesVisible = false"
/>

<app-alerts-list
  [alerts]="alerts"
  [entityType]="EntityType.Company"
  [entity]="entityForAlerts"
  [opened]="alertsVisible"
  (close)="alertsVisible = false"
  (alertReaded)="onAlertReaded($event)"
/>
